// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DriverRelaySlot, IDriverRelaySlot } from "./DriverRelaySlot.gen";
import { DriverSummaryAlert, IDriverSummaryAlert } from "./DriverSummaryAlert.gen";
import { DriverPermissions, IDriverPermissions } from "./DriverPermissions.gen";
import { DriverOverrideState, IDriverOverrideState } from "./Shared.Models.Api.V1.DriverOverrideState.gen";
import { DeviceStatus } from "./DeviceStatus.gen";

export interface IDriverSummary {
	deviceId: string | undefined;

	deviceName: string | undefined;

	facilityName: string | undefined;

	deviceKey: string | undefined;

	status: DeviceStatus;

	lastHeartbeat: string | undefined;

	firmwareVersion: string | undefined;

	ipv4Address: string | undefined;

	height: number;

	offsetFromCentre: number;

	uptimeSeconds: number | undefined;

	cellSignal: number | undefined;

	hardwareStatusAt: string | undefined;

	storageFreeBytes: number | undefined;

	storageTotalBytes: number | undefined;

	storageDvrBytes: number | undefined;

	earliestDvrStart: string | undefined;

	dvrRetentionHours: number;

	dvrFps: number;

	dvrResolutionX: number;

	dvrResolutionY: number;

	dvrBitrateBps: number;

	videoFps: number;

	videoResolutionX: number;

	videoResolutionY: number;

	videoBitrateBps: number;

	relayEndpointId: string | undefined;

	relays: IDriverRelaySlot[] | undefined;

	alerts: IDriverSummaryAlert[] | undefined;

	permissions: IDriverPermissions | undefined;

	overrides: IDriverOverrideState | undefined;

	$type?: string | undefined;
}
export class DriverSummary {
	constructor(data?: IDriverSummary) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastHeartbeat) { this.lastHeartbeat = new Date(data.lastHeartbeat); }
		if (data.hardwareStatusAt) { this.hardwareStatusAt = new Date(data.hardwareStatusAt); }
		if (data.earliestDvrStart) { this.earliestDvrStart = new Date(data.earliestDvrStart); }
		this.relays = data.relays ? data.relays.map((r: any) => new DriverRelaySlot(r)) : [];
		this.alerts = data.alerts ? data.alerts.map((a: any) => new DriverSummaryAlert(a)) : [];
		if (data.permissions) { this.permissions = new DriverPermissions(data.permissions); }
		if (data.overrides) { this.overrides = new DriverOverrideState(data.overrides); }
	}

	deviceId: string | undefined;

	deviceName: string | undefined;

	facilityName: string | undefined;

	deviceKey: string | undefined;

	status: DeviceStatus = 0;

	lastHeartbeat: Date | undefined = new Date();

	firmwareVersion: string | undefined;

	ipv4Address: string | undefined;

	height: number = 0;

	offsetFromCentre: number = 0;

	uptimeSeconds: number | undefined;

	cellSignal: number | undefined;

	hardwareStatusAt: Date | undefined;

	storageFreeBytes: number | undefined;

	storageTotalBytes: number | undefined;

	storageDvrBytes: number | undefined;

	earliestDvrStart: Date | undefined;

	dvrRetentionHours: number = 0;

	dvrFps: number = 0;

	dvrResolutionX: number = 0;

	dvrResolutionY: number = 0;

	dvrBitrateBps: number = 0;

	videoFps: number = 0;

	videoResolutionX: number = 0;

	videoResolutionY: number = 0;

	videoBitrateBps: number = 0;

	relayEndpointId: string | undefined;

	relays: DriverRelaySlot[] | undefined = [];

	alerts: DriverSummaryAlert[] | undefined = [];

	permissions: DriverPermissions | undefined;

	overrides: DriverOverrideState | undefined;

	static $type: string = "CoreApi.Models.DriverSummary, ";
	$type?: string | undefined = DriverSummary.$type;
}

